import React from 'react';
import PropTypes from 'prop-types';

import { indexToLetter } from 'helpers/sharedJsHelpers';

import WYSIWYG from 'components/WYSIWYG';
import Image from 'components/media/Image';
import PeerComparisonGraph from './LegacyPeerComparisonGraph';

const LegacyExplanation = ({ question, peerComparisonPercents }) => {
  const difficultyLevel = question.difficulty_level;
  const correctAnswers = question.answers.filter(answer => answer.is_correct);

  // We need to split the explanation on newlines and wrap each part in a <p> tag
  return (
    <div className="question-explanation">
      { (question.type === 'MultipleChoiceQuestion' && question.correct_answer_ids.size === 1) && (
        <div className="question-correct-answer">
          Correct Answer:&nbsp;
          { indexToLetter(correctAnswers[0].choice) }.&nbsp;
          <WYSIWYG className="answer-name">{correctAnswers[0].safe_name}</WYSIWYG>
        </div>
      )}
      <WYSIWYG className="question-explanation-content">{ question.safe_explanation }</WYSIWYG>
      { question.explanation_images.size > 0 && (
        <ul className="explanation-images">
          { question.explanation_images.map((image, key) => (
            <li className="explanation-image" key={key}>
              <Image image={image} />
            </li>
          )) }
        </ul>
      )}
      { question.plain_reference !== '' && (
        <div>
          <h5 className="question-reference-heading">References:</h5>
          <WYSIWYG className="question-reference">{ question.safe_reference }</WYSIWYG>
        </div>
      )}
      { peerComparisonPercents && <PeerComparisonGraph peerComparisonPercents={peerComparisonPercents} /> }
      { difficultyLevel && (
        <div className="difficulty-level">
          <span className="header">Difficulty: </span><br />
          <span className={`${difficultyLevel} value`} />
        </div>
      ) }
    </div>
  );
};

LegacyExplanation.propTypes = {
  question: PropTypes.object.isRequired,
  peerComparisonPercents: PropTypes.object
};

export default LegacyExplanation;
